import Headers from "../Header/Header";
import MainPage from "./MainPage";
import Services from "./Services";
import Experts from "./Experts";
import Application from "./Application";
import Footer from "./Footer";
import RealEstate from "./RealEstate";
import "../style.css";
const Landing = () => {
  return (
    <div>
      <Headers />
      <MainPage />
      <Services />
      <Experts />
      <RealEstate />
      <Application />
      <Footer />
    </div>
  );
};

export default Landing;
